import { render, staticRenderFns } from "./addPaIndexModel.vue?vue&type=template&id=95de9688&"
import script from "./addPaIndexModel.vue?vue&type=script&lang=js&"
export * from "./addPaIndexModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports